import { formatuseFormErrors } from '../helpers/utils'
import ErrorAlert from './Alerts/ErrorAlert'

export const ErrorsComponent = ({ errors }) => {
    return Object.values(errors).length > 0 ? (
        <ErrorAlert
            error={formatuseFormErrors(errors)}
            heading={'Please fix following error(s).'}
        />
    ) : null
}
